import { RateOutput } from "@/common/types/trpc";

export const getTicketsPurchasedIndex = (rates: RateOutput[], rateId: string): number =>
  rates.findIndex((rate) => rate.id === rateId);
